import Vue from 'vue'
import Vuex from 'vuex'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'
import CardViewer from './components/CardViewer.vue'
import Commenter from './components/Commenter.vue'
import CardScroll from './components/CardScroll.vue'
import Dashboard from './components/Dashboard.vue'
import Auth from '@okta/okta-vue'
import vuetify from './plugins/vuetify'

import {store} from './store'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VueMeta)

Vue.use(Auth, {
  issuer: 'https://dev-537133.okta.com/oauth2/default',
  client_id: '0oao878bgw5vGosB44x6',
  redirect_uri: 'http://localhost:8080/implicit/callback',
  scope: 'openid profile email'
})

const routes = [
  { path: '/implicit/callback', component: Auth.handleCallback() },
  { path: '/', components: {
      default: CardViewer,
      cardscroll: CardScroll,
      commenter: Commenter
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  router,
  vuetify,
  store,
  render: h => h(Dashboard)
}).$mount('#app')
